import { getSrcs } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import * as React from 'react';
import { FocusRing, FocusScope } from 'react-aria';
import S from './Modal.styles';
const Modal = ({ content, isVisible = false, onClick }) => {
    // React.useEffect(() => {
    //   document.body.classList.toggle('modal-open', isVisible);
    // }, [isVisible]);
    const srcs = getSrcs(content.image, 600, 375, 10);
    return (React.createElement(React.Fragment, null, isVisible &&
        React.createElement(FocusScope, { contain: true, autoFocus: true, restoreFocus: true },
            React.createElement(S.Container, { "aria-modal": "true", "data-visible": isVisible, flush: "both" },
                React.createElement(S.Inner, null,
                    React.createElement(S.MediaContainer, null,
                        React.createElement(S.ImageWrapper, null,
                            React.createElement(S.Image, { alt: content.image.altText ?? '', loading: "lazy", role: content.image.altText ? undefined : 'presentation', src: srcs[0], srcSet: srcs.join(',') }))),
                    React.createElement(S.ContentContainer, null,
                        React.createElement(S.ContentInner, null,
                            React.createElement(S.Title, null, content.title),
                            content.subTitle && React.createElement(S.Subtitle, null, content.subTitle),
                            content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content.content ?? '' } })),
                        React.createElement(S.OverlayTop, null),
                        React.createElement(S.OverlayBottom, null)),
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.CloseBtn, { type: "button", onClick: () => onClick(), onKeyDown: (event) => {
                                if (event.key === 'Escape') {
                                    onClick();
                                }
                            } }, getSvgFromSystem(SystemIcon.Close))))))));
};
export default Modal;
